<template>
  <o-input
    :modelValue="displayValue"
    type="text"
    inputmode="numeric"
    :placeholder="placeholder"
    :size="size"
    :root-class="rootClass"
    @update:modelValue="onTyping"
    @blur="commit"
    @keydown.enter="commit"
  />
</template>

<script>
// Dollar-amount input with thousands-comma formatting that commits its
// parsed numeric value to the parent only on blur (or Enter) — not on every
// keystroke — so downstream chart watchers don't recompute mid-edit.
export default {
  name: 'FlatDollarInput',
  props: {
    modelValue: { type: Number, default: 0 },
    placeholder: { type: String, default: '0' },
    size: { type: String, default: 'small' },
    rootClass: { type: String, default: 'tw-w-40' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      displayValue: formatDollar(this.modelValue),
    };
  },
  watch: {
    modelValue(v) {
      if (document.activeElement !== this.$el && document.activeElement !== this.$el?.querySelector?.('input')) {
        this.displayValue = formatDollar(v);
      }
    },
  },
  methods: {
    onTyping(raw) {
      this.displayValue = raw == null ? '' : String(raw);
    },
    commit() {
      const parsed = parseDollar(this.displayValue);
      this.displayValue = formatDollar(parsed);
      if (parsed !== this.modelValue) {
        this.$emit('update:modelValue', parsed);
      }
    },
  },
};

function formatDollar(value) {
  if (value == null || value === '') return '';
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  return num.toLocaleString('en-US');
}

function parseDollar(raw) {
  if (raw == null) return 0;
  const cleaned = String(raw).replace(/[^0-9.-]/g, '');
  if (cleaned === '' || cleaned === '-' || cleaned === '.') return 0;
  const num = Number(cleaned);
  return Number.isFinite(num) ? num : 0;
}
</script>
